export default {
  identification: 'आईडी',
  country: 'देश',
  department: 'विभाग',
  description: 'विवरण',
  charge: 'स्थान',
  screen: 'स्क्रीन'
}
